/** Max rating stars / number buttons per row (Figma — wrap after 5). */
export const SURVEY_RATING_ITEMS_PER_ROW = 5

/** Splits 1..max into rows of at most `perRow` items; a short last row stays centered in the UI. */
export function chunkRatingScaleValues(
  max: number,
  perRow: number = SURVEY_RATING_ITEMS_PER_ROW,
): number[][] {
  if (max <= 0) return []
  const values = Array.from({ length: max }, (_, i) => i + 1)
  const rows: number[][] = []
  for (let i = 0; i < values.length; i += perRow) {
    rows.push(values.slice(i, i + perRow))
  }
  return rows
}
